import { Citation } from "@coffee/data-access/api-types";
import { SecondaryButton } from "@coffee/ui/components/buttons";
import styled from "@emotion/styled";
import { ArrowUpRightIcon } from "@heroicons/react/24/solid";
import { Icon } from "@unlikelyai-magic/ui/icons";
import { Spacing } from "@unlikelyai-magic/ui/layouts";
import { Paragraph } from "@unlikelyai-magic/ui/typography";
import { Citations } from "./Citations";

const Container = styled(Spacing)`
  width: 100%;
`;

type AnswerWidgetProps = {
  citations: Citation[];
  toggleDetailedExplanation: () => void;
};

export const AnswerWidget = ({
  citations,
  toggleDetailedExplanation,
}: AnswerWidgetProps) => {
  return (
    <Container direction="vertical" gap="xs">
      <div>
        {/* div required as otherwise this button will take up the full width rather than just the width it requires */}
        <SecondaryButton onClick={toggleDetailedExplanation}>
          Detailed Explanation
        </SecondaryButton>
      </div>
      <Spacing direction="horizontal" justify="space-between" items="center">
        <a
          href={"/assets/policy.pdf"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Spacing direction="horizontal" gap="xs" items="center">
            <Paragraph>Remote Work Eligibility Policy</Paragraph>
            <Icon icon={ArrowUpRightIcon} size="1rem" />
          </Spacing>
        </a>
      </Spacing>
      <Citations citations={citations} />
    </Container>
  );
};
